import { render, staticRenderFns } from "./CarbonEmssionByBuild.vue?vue&type=template&id=caa792d4&scoped=true&"
import script from "./CarbonEmssionByBuild.vue?vue&type=script&lang=js&"
export * from "./CarbonEmssionByBuild.vue?vue&type=script&lang=js&"
import style0 from "./CarbonEmssionByBuild.vue?vue&type=style&index=0&id=caa792d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa792d4",
  null
  
)

export default component.exports